module.exports = __webpack_public_path__ + "img/glove.e7de5d4b.svg";